import React, { Component } from 'react'
import { Container, Success } from './password.style'
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router-dom'
import { routes } from '../../../../../constants/routes.constants'
import { MuvicardService as ms } from '../../../../../services/muvicard.service'

class ConfirmPasswordComponent extends Component {
	constructor(props) {
		super(props)

		this.state = {
			success: false
		}
	}

	comparePasswords = e => {
		const { passwordConfirmation, password, codigo } = this.props.values
		if (e.target.value.length === 4) {
			if (passwordConfirmation === password) {
				ms.RedefinePassword(codigo, password).then(res => {
					if (res.data.success) {
						this.setState({ success: true })
					} else {
						this.props.toastError({
							message: res.data.errors[0]
						})
					}
				})
			} else {
				this.props.toastError({ message: 'As senhas não são iguais' })
				this.setState({ success: false })
				this.clear()
			}
		}
	}

	clear = () => {
		this.props.setFieldValue('passwordConfirmation', '', true)
	}

	back = step => {
		this.props.prevStep(step)
	}

	render() {
		const { success } = this.state
		const { handleChange, errors, handleBlur, step } = this.props
		const { passwordConfirmation } = this.props.values

		return (
			<React.Fragment>
				<Container>
					<header>
						<h2>Confirme sua senha</h2>
					</header>

					<div>
						<input
							min="0"
							inputmode="numeric"
							autoFocus
							type="password"
							maxLength="4"
							autoComplete="off"
							name="passwordConfirmation"
							pattern="[0-9]*"
							placeholder="****"
							id="passwordConfirmation"
							value={passwordConfirmation}
							onChange={handleChange}
							onBlur={handleBlur}
							onKeyUp={e => this.comparePasswords(e)}
						/>
						<div className="msg-error">{errors.passwordConfirmation}</div>
					</div>

					<footer className="footer">
						<button
							className="button"
							type="button"
							onClick={() => this.back(step)}>
							Voltar
						</button>
						<button
							className="button transparent"
							type="reset"
							onClick={() => this.clear()}>
							Limpar
						</button>
					</footer>
				</Container>
				{/* menssagem de sucesso */}
				{success ? (
					<Success>
						<div className="box-success">
							<FontAwesome
								name="check-circle"
								size="2x"
								className="icon green"
							/>
							<p>Senha redefinida com sucesso!</p>
							<Link to={routes.MEU_CARTAO} className="lk-mycard">
								Voltar para a seção "Meu Cartão"
							</Link>
						</div>
					</Success>
				) : (
					''
				)}
			</React.Fragment>
		)
	}
}

export default ConfirmPasswordComponent
